<h1 mat-dialog-title>Arbeitszeiten exportieren</h1>
<app-detail-list-template *ngIf="initialised$ | async; else loading" [Editing]="true" [Inline]="true" [Data]="TemplateData"></app-detail-list-template>
<mat-dialog-actions>
    <button app-button mat-dialog-close Inverted Color="cancel">Abbrechen</button>
    <button app-button (click)="Export()" [Disabled]="Form.invalid" [IsLoading]="ls.IsLoading$ | async">Exportieren</button>
</mat-dialog-actions>
<ng-template #loading>
    <app-loading></app-loading>
</ng-template>
